import { EqualsIcon } from 'public/svg/IconsSvg';

export const VirtualSetEqualsIcon: FC = () => {
    return (
        <div className="flex h-7 w-7 flex-col items-center justify-center rounded-full bg-green">
            <EqualsIcon className="h-4 w-4 stroke-[3] text-white" />
        </div>
    );
};
